import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    mapIconSrc,
} from './functions';

import styles from './PrimaryButton.module.scss';

const PrimaryButton: FC<IProps> = (props) => {
    return (
        <button
            className={
                classNames(styles.primaryButton, props.className, {
                    [styles.isGreen]: props.color === 'green',
                    [styles.isRed]: props.color === 'red',
                    [styles.isYellow]: props.color === 'yellow',
                    [styles.isPale]: props.isPale,
                    [styles.isDisabled]: props.isDisabled,
                })
            }
            type={props.type ?? 'button'}
            disabled={props.isDisabled}
            onClick={props.onClick}
        >
            {
                props.icon &&
                <img
                    className={styles.icon}
                    src={mapIconSrc(props.icon)}
                    alt={''}
                />
            }
            {props.children}
        </button>
    );
};

export default PrimaryButton;
